/* global validatePassword */

//= require helpers/humanize_regexp
//= require helpers/humanize_password_rules
//= require helpers/validate_password

;(function ($) {
  'use strict'

  var pluginName = 'passwordForm'

  function Plugin(element, options) {
    var $container = $(element)
    var $password = $container.find('.password--password')
    var $confirm = $container.find('.password--confirm')
    var rules = options.rules

    function applyConstraints() {
      var $inputs = $password.add($confirm)

      if (rules.password_length) {
        $inputs.attr('minlength', rules.password_length)
      }
    }

    function checkValidMatch() {
      return $password.val() !== '' && $password.val() === $confirm.val()
    }

    function setCustomValidity(element, message) {
      element.setCustomValidity(message)
      element.dataset['customValidity'] = message
    }

    function updateInputValidity(input) {
      if (input.id === 'setup_confirm_password' && !checkValidMatch()) {
        setCustomValidity(input, 'Password confirmation must match password')
        return
      }

      /** @type {[boolean, string[], string[]]} */
      var validation = validatePassword($password.val(), rules)
      if (validation[0]) {
        setCustomValidity(input, '')
      } else {
        // `validatePassword` doesn't actually check the `history_length` rule,
        // so just ignore it. That validation must be handled by the backend.
        var selectedRuleName = _.without(validation[2], 'history_length')[0]
        if (!selectedRuleName) {
          setCustomValidity(input, 'Password must match requirements')
          return
        }

        var cleanedRuleName = selectedRuleName
        if (/^character_patterns/.test(selectedRuleName))
          cleanedRuleName = 'character_patterns'

        /** @type {{description: string, sanitizedRule: string}[] | null} */
        var humanizedError = window.humanizePasswordRule(
          rules[cleanedRuleName],
          cleanedRuleName
        )
        if (humanizedError) {
          var specificError = humanizedError.find(function (error) {
            return error.sanitizedRule === selectedRuleName
          })
          specificError = specificError || humanizedError[0]
          setCustomValidity(input, specificError.description)
        }
      }
    }

    function onInput(e) {
      var result = validatePassword($password.val(), rules)

      e.preventDefault()

      if (Object.prototype.hasOwnProperty.call(e, 'key') && e.key === 'Enter')
        return
      else if ((e.charCode || e.keyCode) === 13) return

      updateInputValidity($password.get(0))

      var confirmInput = $confirm.get(0)
      if ($password.val().trim() === '') {
        $confirm.attr('disabled', true)
        setCustomValidity(
          confirmInput,
          'Password must be set before it can be confirmed'
        )
      } else {
        $confirm.attr('disabled', false)
        updateInputValidity(confirmInput)
      }

      if (result[0] && checkValidMatch()) {
        $container.trigger('valid.' + pluginName)
      } else {
        $container.trigger('invalid.' + pluginName)
      }
    }

    function initialize() {
      applyConstraints()

      var namespace = '.' + pluginName
      var events = ['change', 'keyup']
        .map(function (event) {
          return event + namespace
        })
        .join(' ')

      $password.off(namespace).on(events, onInput)
      $confirm.off(namespace).on(events, onInput)

      setTimeout(function () {
        $password.trigger('keyup')
      })
    }
    initialize()
  }

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options))
      }
    })
  }
})(window.jQuery)
